import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { goodsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const addGoodsItem = (data: goodsTypes.AddItemData) => {
  return axios.put('/goods', data);
};

type AddGoodsItemOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof addGoodsItem>;
};

export function useAddGoodsItem({ config = {}, department, onSuccess }: AddGoodsItemOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['goods', department]);
      toasts.loadingToast.success('add-goods-item', 'Goods item added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-goods-item', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-goods-item', 'Adding goods item...');
      config.onMutate?.(...args);
    },
    mutationFn: addGoodsItem,
  });
}
